<div id="sc_keyboard" class="keyboard" [class.keyboard-open]="keyboard.open" [class.keyboard-alpha]="keyboard.alpha"
  [class.keyboard-numeric]="keyboard.numeric" [class.keyboard-symbol]="keyboard.symbol"
  [class.keyboard-uppercase]="keyboard.uppercase" [class.keyboard-numrow]="keyboard.numrow"
  (mousedown)="preventBlur($event)">
  <div class="keys numrow">
    <div>
      <button class="key" type="button" (click)="onClick($event,'1')" (mousedown)="preventBlur($event)">1</button>
      <button class="key" type="button" (click)="onClick($event,'2')" (mousedown)="preventBlur($event)">2</button>
      <button class="key" type="button" (click)="onClick($event,'3')" (mousedown)="preventBlur($event)">3</button>
      <button class="key" type="button" (click)="onClick($event,'4')" (mousedown)="preventBlur($event)">4</button>
      <button class="key" type="button" (click)="onClick($event,'5')" (mousedown)="preventBlur($event)">5</button>
      <button class="key" type="button" (click)="onClick($event,'6')" (mousedown)="preventBlur($event)">6</button>
      <button class="key" type="button" (click)="onClick($event,'7')" (mousedown)="preventBlur($event)">7</button>
      <button class="key" type="button" (click)="onClick($event,'8')" (mousedown)="preventBlur($event)">8</button>
      <button class="key" type="button" (click)="onClick($event,'9')" (mousedown)="preventBlur($event)">9</button>
      <button class="key" type="button" (click)="onClick($event,'0')" (mousedown)="preventBlur($event)">0</button>
    </div>
  </div>
  <div class="keys alpha">
    <div>
      <button class="key" type="button" (click)="onClick($event,'Q')" (mousedown)="preventBlur($event)">Q</button>
      <button class="key" type="button" (click)="onClick($event,'W')" (mousedown)="preventBlur($event)">W</button>
      <button class="key" type="button" (click)="onClick($event,'E')" (mousedown)="preventBlur($event)">E</button>
      <button class="key" type="button" (click)="onClick($event,'R')" (mousedown)="preventBlur($event)">R</button>
      <button class="key" type="button" (click)="onClick($event,'T')" (mousedown)="preventBlur($event)">T</button>
      <button class="key" type="button" (click)="onClick($event,'Y')" (mousedown)="preventBlur($event)">Y</button>
      <button class="key" type="button" (click)="onClick($event,'U')" (mousedown)="preventBlur($event)">U</button>
      <button class="key" type="button" (click)="onClick($event,'I')" (mousedown)="preventBlur($event)">I</button>
      <button class="key" type="button" (click)="onClick($event,'O')" (mousedown)="preventBlur($event)">O</button>
      <button class="key" type="button" (click)="onClick($event,'P')" (mousedown)="preventBlur($event)">P</button>
    </div>
    <div class="asd">
      <button class="key" type="button" (click)="onClick($event,'A')" (mousedown)="preventBlur($event)">A</button>
      <button class="key" type="button" (click)="onClick($event,'S')" (mousedown)="preventBlur($event)">S</button>
      <button class="key" type="button" (click)="onClick($event,'D')" (mousedown)="preventBlur($event)">D</button>
      <button class="key" type="button" (click)="onClick($event,'F')" (mousedown)="preventBlur($event)">F</button>
      <button class="key" type="button" (click)="onClick($event,'G')" (mousedown)="preventBlur($event)">G</button>
      <button class="key" type="button" (click)="onClick($event,'H')" (mousedown)="preventBlur($event)">H</button>
      <button class="key" type="button" (click)="onClick($event,'J')" (mousedown)="preventBlur($event)">J</button>
      <button class="key" type="button" (click)="onClick($event,'K')" (mousedown)="preventBlur($event)">K</button>
      <button class="key" type="button" (click)="onClick($event,'L')" (mousedown)="preventBlur($event)">L</button>
    </div>
    <div>
      <button class="key-symbol gray-bg" type="button" (click)="onClick($event,KEYS.SHIFT)"
        (mousedown)="preventBlur($event)" [disabled]="upperCaseOnly">
        <img class="shiftkey" src="../../../../assets/images/keyboard/icon-shift.png" />
        <img class="shiftkey active" src="../../../../assets/images/keyboard/icon-shift-active.png" />
      </button>
      <button class="key" type="button" (click)="onClick($event,'Z')" (mousedown)="preventBlur($event)">Z</button>
      <button class="key" type="button" (click)="onClick($event,'X')" (mousedown)="preventBlur($event)">X</button>
      <button class="key" type="button" (click)="onClick($event,'C')" (mousedown)="preventBlur($event)">C</button>
      <button class="key" type="button" (click)="onClick($event,'V')" (mousedown)="preventBlur($event)">V</button>
      <button class="key" type="button" (click)="onClick($event,'B')" (mousedown)="preventBlur($event)">B</button>
      <button class="key" type="button" (click)="onClick($event,'N')" (mousedown)="preventBlur($event)">N</button>
      <button class="key" type="button" (click)="onClick($event,'M')" (mousedown)="preventBlur($event)">M</button>
      <button class="key-symbol key-delete gray-bg" type="button" (click)="onClick($event,KEYS.DELETE)"
        (mousedown)="preventBlur($event)" (mouseup)="clearDeleteTimeout($event)" (touchend)="clearDeleteTimeout($event)"
        (touchstart)="touchStart($event)">
        <img src="../../../../assets/images/keyboard/icon-delete.png" />
      </button>
    </div>
    <div>
      <button class="key gray-bg" type="button" (click)="onClick($event,KEYS.NUMERIC)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.NUMERIC"></button>
      <button class="key-space" type="button" (click)="onClick($event,KEYS.SPACE)"
        (mousedown)="preventBlur($event)">SPACE</button>
      <button class="gray-bg" type="button" (click)="onClick($event,KEYS.ENTER)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.ENTER"></button>
    </div>
  </div>
  <div class="keys numeric">
    <div>
      <button class="key" type="button" (click)="onClick($event,'1')" (mousedown)="preventBlur($event)">1</button>
      <button class="key" type="button" (click)="onClick($event,'2')" (mousedown)="preventBlur($event)">2</button>
      <button class="key" type="button" (click)="onClick($event,'3')" (mousedown)="preventBlur($event)">3</button>
      <button class="key" type="button" (click)="onClick($event,'4')" (mousedown)="preventBlur($event)">4</button>
      <button class="key" type="button" (click)="onClick($event,'5')" (mousedown)="preventBlur($event)">5</button>
      <button class="key" type="button" (click)="onClick($event,'6')" (mousedown)="preventBlur($event)">6</button>
      <button class="key" type="button" (click)="onClick($event,'7')" (mousedown)="preventBlur($event)">7</button>
      <button class="key" type="button" (click)="onClick($event,'8')" (mousedown)="preventBlur($event)">8</button>
      <button class="key" type="button" (click)="onClick($event,'9')" (mousedown)="preventBlur($event)">9</button>
      <button class="key" type="button" (click)="onClick($event,'0')" (mousedown)="preventBlur($event)">0</button>
    </div>
    <div>
      <button class="key" type="button" (click)="onClick($event,KEYS.AT_SIGN)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.AT_SIGN"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.NUM_SIGN)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.NUM_SIGN"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.DOLLAR_SIGN)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.DOLLAR_SIGN"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.AMPERSAND)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.AMPERSAND"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.UNDERSCORE)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.UNDERSCORE"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.MINUS)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.MINUS"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.OPEN_PAREN)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.OPEN_PAREN"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.CLOSE_PAREN)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.CLOSE_PAREN"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.EQUAL)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.EQUAL"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.PERCENT)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.PERCENT"></button>
    </div>
    <div>
      <button class="key" type="button" (click)="onClick($event,KEYS.SYMBOL)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.SYMBOL"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.QUOTE)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.QUOTE"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.ASTERISK)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.ASTERISK"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.APOSTROPHE)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.APOSTROPHE"> </button>
      <button class="key" type="button" (click)="onClick($event,KEYS.COLON)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.COLON"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.FORWARD_SLASH)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.FORWARD_SLASH"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.EXCLAMATION)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.EXCLAMATION"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.QUESTION_MARK)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.QUESTION_MARK"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.PLUS)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.PLUS"></button>
      <button class="key-symbol key-delete gray-bg" type="button" (click)="onClick($event,KEYS.DELETE)"
        (mousedown)="preventBlur($event)" (mouseup)="clearDeleteTimeout($event)" (touchend)="clearDeleteTimeout($event)"
        (touchstart)="touchStart($event)">
        <img src="../../../../assets/images/keyboard/icon-delete.png" />
      </button>
    </div>
    <div>
      <button class="gray-bg" type="button" (click)="onClick($event,KEYS.ALPHA)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.ALPHA"></button>
      <button class="key-symbol" type="button" (click)="onClick($event,KEYS.COMMA)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.COMMA"></button>
      <button class="key-space" type="button" (click)="onClick($event,KEYS.SPACE)"
        (mousedown)="preventBlur($event)">SPACE</button>
      <button class="key-symbol" type="button" (click)="onClick($event,KEYS.PERIOD)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.PERIOD"></button>
      <button class="gray-bg" type="button" (click)="onClick($event,KEYS.ENTER)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.ENTER"></button>
    </div>
  </div>
  <div class="keys symbol">
    <div>
      <button class="key" type="button" (click)="onClick($event,KEYS.EURO)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.EURO"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.POUND)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.POUND"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.YEN)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.YEN"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.CENT)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.CENT"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.COPYRIGHT)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.COPYRIGHT"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.REGISTERED_TM)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.REGISTERED_TM"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.TRADEMARK)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.TRADEMARK"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.TILDE)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.TILDE"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.INVERTED_QUESTION)"
        (mousedown)="preventBlur($event)" [innerHTML]="KEYS.INVERTED_QUESTION"></button>
    </div>
    <div><button class="gray-bg" type="button" (click)="onClick($event,KEYS.NUMERIC)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.NUMERIC"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.OPEN_SQUARE)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.OPEN_SQUARE"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.CLOSE_SQUARE)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.CLOSE_SQUARE"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.OPEN_CURLY)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.OPEN_CURLY"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.CLOSE_CURLY)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.CLOSE_CURLY"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.LESS_THAN)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.LESS_THAN"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.GREATER_THAN)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.GREATER_THAN"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.CARET)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.CARET"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.INVERTED_EXCLAMATION)"
        (mousedown)="preventBlur($event)" [innerHTML]="KEYS.INVERTED_EXCLAMATION"></button>
    </div>
    <div><button class="key gray-bg" type="button" (click)="onClick($event,KEYS.ALPHA)"
        (mousedown)="preventBlur($event)" [innerHTML]="KEYS.ALPHA"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.BACKTICK)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.BACKTICK"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.SEMICOLON)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.SEMICOLON"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.DIVIDE)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.DIVIDE"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.BACKSLASH)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.BACKSLASH"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.VERTICAL_BAR)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.VERTICAL_BAR"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.BROKEN_VERTICAL_BAR)"
        (mousedown)="preventBlur($event)" [innerHTML]="KEYS.BROKEN_VERTICAL_BAR"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.NOT)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.NOT"></button>
      <button class="key-symbol key-delete gray-bg" type="button" (click)="onClick($event,KEYS.DELETE)"
        (mousedown)="preventBlur($event)" (mouseup)="clearDeleteTimeout($event)" (touchend)="clearDeleteTimeout($event)"
        (touchstart)="touchStart($event)">
        <img src="../../../../assets/images/keyboard/icon-delete.png" />
      </button>
    </div>
    <div>
      <button class="key-space" type="button" (click)="onClick($event,KEYS.SPACE)"
        (mousedown)="preventBlur($event)">SPACE</button>
      <button class="key" type="button" (click)="onClick($event,KEYS.TIMES)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.TIMES"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.SECTION)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.SECTION"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.PARAGRAPH)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.PARAGRAPH"></button>
      <button class="key" type="button" (click)="onClick($event,KEYS.ORDINAL_INDICATOR_M)"
        (mousedown)="preventBlur($event)" [innerHTML]="KEYS.ORDINAL_INDICATOR_M"></button>
      <button class="gray-bg" type="button" (click)="onClick($event,KEYS.ENTER)" (mousedown)="preventBlur($event)"
        [innerHTML]="KEYS.ENTER"></button>
    </div>
  </div>
</div>